export function rafThrottler(callback) {
  let rafId = null;
  const flush = () => {
    callback();
    rafId = null;
  };

  return () => {
    if (rafId) {
      return;
    }

    rafId = requestAnimationFrame(flush);
  };
}
